<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
    <!-- <CalendarArrowLeft /> -->
  </div>
</template>

<script>
// import CalendarArrowLeft from "vue-material-design-icons/CalendarArrowLeft.vue"

import SvgIcon from '@jamescoyle/vue-icon';
import { mdiCalendarArrowLeft } from "@mdi/js"

export default {
  name: "CalendarArrowLeftIcon",
  components: {
    SvgIcon
    // CalendarArrowLeft,
  },
  data() {
    return {
      path: mdiCalendarArrowLeft,
    }
  }
}
</script>
